'use es6';

import createStandardI18nProvider from './createStandardI18nProvider';
import { PUBLIC_CACHE } from '../internal/localeCacheKeys';
export default (function (options) {
  var I18nProvider = createStandardI18nProvider(Object.assign({}, options, {
    __localesCacheKey: PUBLIC_CACHE
  }));

  if (!options || options && !options.manuallySetLocale) {
    I18nProvider.setLocale({
      locale: navigator && navigator.languages && navigator.languages[0],
      langEnabled: true
    });
  }

  return I18nProvider;
});